<template>
  <div>
    <div class="bg-blue-900 p-4 lg:p-12">
      <div class="max-w-5xl mx-auto">
        <div class="flex flex-col md:flex-row md:items-center">
          <h4 class="text-white font-bold">Edit Client</h4>

          <div class="flex md:ml-auto mt-4 md:mt-0">
            <BaseButton
              tag="router-link"
              :to="{
                name: 'accounts.accountId.clients.clientUuid',
                params: {
                  ...$route.params,
                },
              }"
              primary
              class="ml-auto md:ml-4"
            >
              Back
            </BaseButton>
          </div>
        </div>
      </div>
    </div>

    <div class="p-4 lg:p-12">
      <div class="max-w-5xl mx-auto">
        <ValidationObserver ref="observer">
          <template #default="{ handleSubmit }">
            <ClientForm
              :disabled="isLoading"
              :name.sync="formData.name"
              :opening-balance.sync="formData.openingBalance"
              :credit-limit.sync="formData.creditLimit"
              @submit="handleSubmit(tryUpdate)"
            />
          </template>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ClientForm from '@/components/AccountClients/ClientForm.vue';
import store from '@/store';
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';

const STATUS_IDLE = 'idle';
const STATUS_LOADING = 'loading';
const STATUS_RESOLVED = 'resolved';
const STATUS_REJECTED = 'rejected';

export default {
  mixins: [veeValidateErrorsMixin],

  components: {
    ClientForm,
  },

  props: {
    clientUuid: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      status: STATUS_IDLE,
      formData: {
        name: '',
        openingBalance: 0,
        creditLimit: 0,
      },
      response: {
        errors: null,
        message: '',
      },
    };
  },

  computed: {
    ...mapGetters('ui/accountClients', ['client']),
    isLoading() {
      return this.status === STATUS_LOADING;
    },
    isResolved() {
      return this.status === STATUS_RESOLVED;
    },
    isRejected() {
      return this.status === STATUS_REJECTED;
    },
  },

  watch: {
    client: {
      deep: true,
      handler: 'setData',
    },
  },

  async beforeRouteEnter(to, from, next) {
    const { clientUuid: accountClientUuid } = to.params;

    try {
      await store.dispatch('ui/accountClients/read', { accountClientUuid });
      next();
    } catch (error) {
      next(false);
    }
  },

  created() {
    this.setData(this.client);
  },

  methods: {
    ...mapActions('ui/accountClients', {
      updateClient: 'update',
    }),

    setData({ name = '', openingBalance = 0, creditLimit = 0 } = {}) {
      this.formData.name = name;
      this.formData.openingBalance = openingBalance;
      this.formData.creditLimit = creditLimit;
    },

    async tryUpdate() {
      this.status = STATUS_LOADING;

      const { formData, clientUuid: accountClientUuid } = this;

      try {
        await this.updateClient({ accountClientUuid, formData });

        this.status = STATUS_RESOLVED;
      } catch (error) {
        /** handler error */
        this.status = STATUS_REJECTED;
      }
    },
  },
};
</script>
